var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Schedule',{ref:"table",attrs:{"crm":_vm.crm,"user":_vm.user,"roles":_vm.roles,"officers":_vm.officers,"crm-setting-value":_vm.crmSettingValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }